import {
  CheckCircleFilled,
  LoadingOutlined,
  LockOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import { Switch } from "antd";
import { FC } from "react";
import {
  PROJECT_PHASE_LABELS,
  PROJECT_PHASES,
  ProjectPhase,
  ProjectPhasePermissions,
  ProjectPhaseSummaries,
} from "../../projectPhase";
import "./index.css";

interface ProjectPhaseSwitcherProps {
  activePhase: ProjectPhase;
  permissions: ProjectPhasePermissions;
  summaries: ProjectPhaseSummaries;
  canManage: boolean;
  disabled: boolean;
  loadingPhase?: ProjectPhase;
  onPhaseChange: (phase: ProjectPhase) => void;
  onEditableChange: (phase: ProjectPhase, editable: boolean) => void;
}

const ProjectPhaseSwitcher: FC<ProjectPhaseSwitcherProps> = ({
  activePhase,
  permissions,
  summaries,
  canManage,
  disabled,
  loadingPhase,
  onPhaseChange,
  onEditableChange,
}) => (
  <div className="projectPhaseSwitcher" aria-label="项目阶段">
    {PROJECT_PHASES.map((phase, index) => {
      const editable = permissions[phase];
      const completed = summaries[phase].is_completed;
      const loading = loadingPhase === phase;
      return (
        <div
          className={`projectPhaseSwitcher__item ${
            activePhase === phase ? "projectPhaseSwitcher__item--active" : ""
          }`}
          key={phase}
        >
          <button
            aria-label={`切换到${PROJECT_PHASE_LABELS[phase]}`}
            className="projectPhaseSwitcher__select"
            disabled={disabled}
            onClick={() => onPhaseChange(phase)}
            type="button"
          >
            <span className="projectPhaseSwitcher__index">{index + 1}</span>
            <span className="projectPhaseSwitcher__copy">
              <strong>{PROJECT_PHASE_LABELS[phase]}</strong>
              <span className="projectPhaseSwitcher__statusRow">
                {loading && (
                  <span className="projectPhaseSwitcher__status projectPhaseSwitcher__status--loading">
                    <LoadingOutlined spin /> 加载中
                  </span>
                )}
                {completed && (
                  <span className="projectPhaseSwitcher__status projectPhaseSwitcher__status--completed">
                    <CheckCircleFilled /> 已完成
                  </span>
                )}
                {editable ? (
                  <span className="projectPhaseSwitcher__status projectPhaseSwitcher__status--editable">
                    <UnlockOutlined /> 编辑开放
                  </span>
                ) : (
                  <span className="projectPhaseSwitcher__status projectPhaseSwitcher__status--readonly">
                    <LockOutlined /> 只读
                  </span>
                )}
                <span className="projectPhaseSwitcher__count">
                  {summaries[phase].completed}/{summaries[phase].total}
                </span>
              </span>
            </span>
          </button>
          {canManage && (
            <Switch
              aria-label={`设置${PROJECT_PHASE_LABELS[phase]}编辑权限`}
              checked={editable}
              checkedChildren="开"
              disabled={disabled || loading}
              onChange={(checked) => onEditableChange(phase, checked)}
              size="small"
              unCheckedChildren="关"
            />
          )}
        </div>
      );
    })}
  </div>
);

export default ProjectPhaseSwitcher;
